// src/components/Navigation.jsx
// The site's primary navigation menu.
// Renders a list of <Link> elements that route between pages without reloading.
//
// Editorial framing: link text uses Module 7's editorial labels (Cover, Field Notes,
// Dispatches, Colophon, The Desk) while the underlying routes follow the
// Module 8 spec (/, /projects, /blogs, /about, /contact).
//
// Auth-aware tail: when logged out the nav shows Sign In and Create Account; when
// logged in it shows Profile and a Sign Out button. The Admin Dashboard stays out
// of the nav (admins reach it from their Profile page), as in Module 8.

import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const navItems = [
  { to: "/", label: "Cover" },
  { to: "/projects", label: "Field Notes" },
  { to: "/blogs", label: "Dispatches" },
  { to: "/about", label: "Colophon" },
  { to: "/contact", label: "The Desk" },
];

export default function Navigation() {
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/");
  }

  const linkClasses = "label-mono hover:text-ink transition-colors";

  return (
    <nav className="flex items-baseline gap-6">
      {navItems.map((item) => (
        <Link key={item.to} to={item.to} className={linkClasses}>
          {item.label}
        </Link>
      ))}

      {/* Auth-dependent links */}
      {isLoggedIn ? (
        <>
          <Link to="/profile" className={linkClasses}>
            Profile
          </Link>
          <button
            type="button"
            onClick={handleLogout}
            className={`${linkClasses} bg-transparent border-0 p-0 cursor-pointer`}
          >
            Sign Out
          </button>
        </>
      ) : (
        <>
          <Link to="/login" className={linkClasses}>
            Sign In
          </Link>
          <Link to="/create-account" className={linkClasses}>
            Create Account
          </Link>
        </>
      )}
    </nav>
  );
}
